import { createApp, provide, h } from "vue";
import ViewUIPlus, { LoadingBar, LoadingBarConfig } from "view-ui-plus";
import locale from "view-ui-plus/dist/locale/en-US";
import PortalVue from "portal-vue";
import { createPinia } from "pinia";
import { DefaultApolloClient } from "@vue/apollo-composable";
import "../theme/iview.theme.less";
import "./style/variables.module.css";

import App from "@/App.vue";

import { registerComponents } from "@/components/common";
import { initWithStore as initRouterWithStore } from "@/router";
import store from "@/store";
import { snackbar } from "@/utils";
import { initApollo, apolloClient } from "@/apollo";

/* Init router and store */
const router = initRouterWithStore(store);

/* Init the pinia store */
const pinia = createPinia();
/* Create and init app */
const app = createApp({
    setup() {
        provide(DefaultApolloClient, apolloClient);
    },
    render: () => h(App)
});

app.config.globalProperties.$snackbar = snackbar;

app.use(pinia);
app.use(router);
app.use(store);
app.use(ViewUIPlus, { locale });
app.use(PortalVue);
// app.use(filters);

// we need to use an init function since we need the pinia store to be initialized
// for the baseApiURL used in the apollo client
const apolloProvider = initApollo();

app.use(apolloProvider);

type ActualLoadingBar = typeof LoadingBar & {
    config: (config: typeof LoadingBarConfig) => void;
};

(ViewUIPlus.LoadingBar as ActualLoadingBar).config({
    color: "#5E00B5",
    failedColor: "#f0ad4e",
    height: 2
});

registerComponents(app);

app.mount("#appRoot");
